import { data } from '../../svg/RadioButton/data';
import { makeIcon } from '../makeIcon';

export const RadioButton = makeIcon(data, 'radio_button', 'RadioButton');

export default RadioButton;
